import { createError, SsoError, SsoQueryField } from '@common/neo.tax';
import { useEffect } from 'react';

import { AuthErrorType, AuthenticationState, signInWithCustomToken, useUrlQueryParam } from '@neo.tax/shared';

// handles redirects for SSO (e.g. Intuit, Google)
export const useSsoCustomTokenSignIn = (): void => {
  const authenticationToken = useUrlQueryParam(SsoQueryField.TOKEN);
  const ssoError = useUrlQueryParam(SsoQueryField.ERROR);

  useEffect(() => {
    if (ssoError === SsoError.NEEDS_EMAIL_VERIFICATION) {
      AuthenticationState.updateAuthErrorType(AuthErrorType.INTUIT_EMAIL_NOT_VERIFIED);
    } else if (ssoError === SsoError.QUICKBOOKS_FAILED) {
      // log an error message for engineers to investigate
      // TODO: also display some error message to the user
      // https://linear.app/neo-tax/issue/NEO-2130/intuit-sso-handle-the-error-case-when-quickbooks-token-failed-to
      throw createError('SsoRedirectError', 'Failed on Quickbooks SSO');
    } else if (ssoError) {
      throw createError('SsoRedirectError', `Unknown error: ${ssoError}`);
    }

    if (authenticationToken) {
      // SSO succeeded, log in with the authentication custom token
      (async (): Promise<void> => {
        await signInWithCustomToken(authenticationToken);
      })();
    }
  }, [authenticationToken, ssoError]);
};
